module.exports = __webpack_public_path__ + "img/bgfocus_beastreserve.5184785.png";